<template>
  <div>
    <div class="row">
      <div class="col-4">
        <select class="form-control form-control-sm" @change="selected" v-model="val">
          <optgroup label="Platform Roadmap">
            <option value="SYSTEM_AND_ROADMAP_TUTORIAL"> SYSTEM_AND_ROADMAP_TUTORIAL </option>
            <option value="ORGANIZATION_DETAIL"> ORGANIZATION_DETAIL </option>
            <option value="ORGANIZATION_HIERARCHY"> ORGANIZATION_HIERARCHY </option>
            <option value="THIRD_PARTY"> THIRD_PARTY </option>
          </optgroup>
          <optgroup label="Gdpr Roadmap">
            <option value="GDPR_PRODUCT_TUTORIAL"> GDPR_PRODUCT_TUTORIAL </option>
            <option value="GDPR_DEPARTMENT_QUESTIONS"> GDPR_DEPARTMENT_QUESTIONS </option>
            <option value="GDPR_INVENTORY_UPDATE"> GDPR_INVENTORY_UPDATE </option>
            <option value="GDPR_POLICY"> GDPR_POLICY </option>
            <option value="GDPR_RISK"> GDPR_RISK </option>
            <option value="GDPR_REPORT_PREPARE"> GDPR_REPORT_PREPARE </option>
          </optgroup>
          <optgroup label="KVKK Roadmap">
            <option value="KVKK_PRODUCT_TUTORIAL"> KVKK_PRODUCT_TUTORIAL </option>
            <option value="KVKK_DEPARTMENT_QUESTIONS"> KVKK_DEPARTMENT_QUESTIONS </option>
            <option value="KVKK_INVENTORY_UPDATE"> KVKK_INVENTORY_UPDATE </option>
            <option value="KVKK_POLICY"> KVKK_POLICY </option>
            <option value="KVKK_RISK"> KVKK_RISK </option>
            <option value="KVKK_REPORT_PREPARE"> KVKK_REPORT_PREPARE </option>
          </optgroup>
          <optgroup label="DDO Roadmap">
            <option value="DDO_PLANNING"> DDO_PLANNING </option>
            <option value="DDO_APPLY"> DDO_APPLY </option>
            <option value="DDO_CONTROL_AND_PREVENTION"> DDO_CONTROL_AND_PREVENTION </option>
            <option value="DDO_CHANGE_MANAGEMENT"> DDO_CHANGE_MANAGEMENT </option>
          </optgroup>
          <optgroup label="BGYS Roadmap">
            <option value="BGYS_ORGANIZATION_CONTEXT"> BGYS_ORGANIZATION_CONTEXT </option>
            <option value="BGYS_LEADERSHIP"> BGYS_LEADERSHIP </option>
            <option value="BGYS_PLANNING"> BGYS_PLANNING </option>
            <option value="BGYS_SUPPORT"> BGYS_SUPPORT </option>
            <option value="BGYS_OPERATION"> OPERATION </option>
            <option value="BGYS_PERFORMANCE_RATING"> PERFORMANCE_RATING </option>
            <option value="BGYS_IMPROVEMENT"> IMPROVEMENT </option>
          </optgroup>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import AutoCompleteSelect from "./AutoCompleteSelect";
import { methods } from "./commons";

export default {
  props: ["value"],

  components: { AutoCompleteSelect },
  computed: {
    val: {
      get() {
        return this.value ? this.value.value : undefined;
      },
      set(value) {
        this.$emit("input", {
          ...this.value,
          value,
        });
      },
    },
  },

  methods,
};
</script>
